import React, { useEffect } from "react";

const Reviews = () => {
  useEffect(() => {
    // Cargar el script de Elfsight dinámicamente
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);

    // Limpieza del script si el componente se desmonta
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="py-10 text-center bg-white">
  <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-6">
    <span className="text-green-600">Opiniones de nuestros clientes</span>
  </h2>

  {/* Este div es el contenedor que Elfsight usa para mostrar las reseñas */}
  <div
    className="elfsight-app-2874bf35-f067-455b-8636-d9836e619990"
    data-elfsight-app-lazy
  ></div>
</section>

  );
};

export default Reviews;

